import React from 'react';
import { CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
const Hero = () => {
  return <section className="bg-gradient-to-b from-white to-blue-50 py-16 md:py-24" data-id="element-228">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-229">
        <div className="flex flex-col md:flex-row items-center" data-id="element-230">
          <div className="md:w-1/2 md:pr-12" data-id="element-231">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-232">
              即戦力の清掃スタッフを
              <br className="hidden md:inline" data-id="element-233" />
              貴社のニーズに合わせて
            </h1>
            <p className="text-xl text-gray-700 mb-8" data-id="element-234">
              ホテル、民泊施設、オフィスビルに向けた、信頼できる清掃スタッフを全国の主要都市で提供しております。
            </p>
            <div className="space-y-3 mb-8" data-id="element-235">
              <div className="flex items-center" data-id="element-236">
                <CheckCircleIcon className="h-5 w-5 text-blue-600 mr-2" data-id="element-237" />
                <span className="text-gray-700" data-id="element-238">専門研修を受けたスタッフ</span>
              </div>
              <div className="flex items-center" data-id="element-239">
                <CheckCircleIcon className="h-5 w-5 text-blue-600 mr-2" data-id="element-240" />
                <span className="text-gray-700" data-id="element-241">24時間以内の迅速な手配</span>
              </div>
              <div className="flex items-center" data-id="element-242">
                <CheckCircleIcon className="h-5 w-5 text-blue-600 mr-2" data-id="element-243" />
                <span className="text-gray-700" data-id="element-244">
                  写真付き作業報告で安心品質
                </span>
              </div>
            </div>
            <div className="flex flex-wrap gap-4" data-id="element-245">
              <a href="#contact" className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-md flex items-center" data-id="element-246">
                スタッフ派遣のご相談
                <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-247" />
              </a>
              <a href="#services" className="bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium py-3 px-6 rounded-md" data-id="element-248">
                サービスの詳細
              </a>
            </div>
          </div>
          <div className="md:w-1/2 mt-12 md:mt-0" data-id="element-249">
            <div className="relative" data-id="element-250">
              <div className="absolute inset-0 bg-blue-200 rounded-lg transform translate-x-3 translate-y-3" data-id="element-251"></div>
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8Lcv4duvcuMxhiW92iZo5z/hoteruno-bu-wuno-qing-sao.jpg" alt="Professional cleaning staff making a hotel bed" className="relative z-10 rounded-lg shadow-lg w-full h-auto" data-id="element-252" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;